module.exports = __webpack_public_path__ + "media/alarm.51921886.mp3";